import { getApiKey } from "../../utils/apiKey";
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import axios from "axios";
import { apiCall_domain } from "../api";
import { makeStyles } from "@mui/styles";
import Drawer from "@mui/material/Drawer";
import Spinner from "../Spinner/Spinner";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useHistory } from "routerCompat";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

const ChangeCity = () => {
  const history = useHistory();
  const [mainCity, setMainCity] = useState([]);
  const classes = useStyles();
  const [state, setState] = useState({
    bottom: false,
  });
  const [secMap, setSecMap] = useState();
  const [lastName, setLastName] = useState();
  const [cityId, setCityId] = useState();
  const [loader, setLoader] = useState(true);
  //states

  //api
  useEffect(() => {
    const Headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/splash`, {
        headers: Headers,
      })
      .then((res) => {
        setMainCity(res.data.cities);
        setLoader(false);
      })
      
  }, []);
  //api

  //functions
  const toggleDrawer = (anchor, open, e) => (event) => {
          setSecMap(e);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {secMap &&
          secMap.map((item, key) => (
            <>
              <ListItem>
                <ListItemText
                  primary={item.name}
                  onClick={() => finalCity(item.name, item.id)}
                />
              </ListItem>
              <div className="secCityDivider" />
            </>
          ))}
      </List>
    </div>
  );

  const finalCity = (name, id) => {
    setLastName(name);
    setCityId(id);
    localStorage.setItem("defaultCity", name);
    history.push({
      pathname: "/",
    })

  };
  const defCity = localStorage.getItem("defaultCity");
  //functions
  return (
    <>
      {loader ? (
        <Spinner />
      ) : (
        <main  className="ChangeCity">
          <div className="innerChangeCity">
            <div className="selected">
              <input defaultValue={defCity} value={lastName}></input>
            </div>
            <div className="cityLists">
              {mainCity &&
                mainCity.map((item, i) =>
                  ["bottom"].map((anchor) => (
                    <React.Fragment key={anchor}>
                      <>
                        <div
                          className="cityRow"
                          onClick={toggleDrawer(anchor, true, item.cities)}
                        >
                          <span className="city" key={i}>
                            {item.name}
                          </span>
                        </div>
                        <div className="cityDivider" />
                      </>
                      <Drawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                      >
                        {list(anchor)}
                      </Drawer>
                    </React.Fragment>
                  ))
                )}
            </div>
          </div>
        </main>
      )}
    </>
  );
};

export default ChangeCity;
